import Vue from 'vue';
import {
  Toast
} from 'vant';
import store from "@/store";
import commonFunc from '@/tools/common'
import ZskkController from '@/plug/log'
import router from '../../router'
const formatParams = data => {
  // return { 'zskk-params': commonFunc.isObject(data) ? JSON.stringify(data) : data }
  // return {
  //   'params': commonFunc.isObject(data) ? JSON.stringify(data) : data
  // }
  return commonFunc.isObject(data) ? JSON.stringify(data) : data
  // return { 'zskk-params': commonFunc.isObject(data) ? JSON.stringify(data) : data  }
}


const formatHeaders = data => {
  const common = {}
  const timestamp = new Date().getTime()
  const random = commonFunc.UUID.uuid16()
  const token = store.state.user.token
  const signature = commonFunc.generateSignature(data, timestamp, random, token)
  return {
    common: {
      'zskk-timestamp': timestamp,
      'zskk-random': random,
      'zskk-signature': signature,
      'ZSKK-TOKEN': token
    }
  }
}
let stempParams = {}
let toastInstance = null; // 用于存储 Toast 实例
const requestInterceptor = config => {
  const data = formatParams(config['data'])
  config['data'] = data
  config['headers'] = formatHeaders(data)
  // 如果已经有 Toast 实例，先清除
  if (toastInstance) {
    toastInstance.clear();
  }
  // toastInstance = Toast.loading({
  //   message: '加载中...',
  //   forbidClick: true,
  //   duration: 0,
  // });
  stempParams = data
  return config;
}

const requestInterceptorError = error => {
  if (toastInstance) {
    toastInstance.clear();
  }
  this.$router.push({
    path: '/500'
  })
  new Error('请求失败')
}

const responseInterceptor = response => {
  if (toastInstance) {
    toastInstance.clear();
  }
  ZskkController.ZskkLogController.add(response)
  let {
    data,
    status,
    statusText
  } = response;
  // 处理http请求异常
  if (commonFunc.isErrorNetStatus(status)) {
    throw new Error(statusText)
  }
  //服务端返回data为空
  if (!data) {
    throw new Error('服务端返回数据为空')
  }
  let code = data['code'];
  // let institution_id = JSON.parse(stempParams.params).institution_id
  if (code !== 0) {
  //   if(code === "9987" && (institution_id === '06300009' || institution_id === '13000003')){
  //     router.push({
  //       path: '/verifyPhone',
  //       query: JSON.parse(stempParams.params)
  //     })
  //   }else{
     throw new Error(data['msg'])
  }
  // }
  //这里吧错误响应不再返回到页面，直接统一处理掉，只有正确的返回才会被接收并做下一步处理
  if (commonFunc.checkResponse(data)) {
    return data['data'];
  }
  throw new Error('返回结果校验失败')
}
const responseInterceptorError = error => {
  if (toastInstance) {
    toastInstance.clear();
  }
  throw new Error(error.message)
  // return Promise.reject(error);
}
const NetworkInterceptor = {
  requestInterceptor,
  requestInterceptorError,
  responseInterceptor,
  responseInterceptorError
}

export default NetworkInterceptor;